<header>
    <app-admin-header></app-admin-header>
  </header>
  <main>
    <router-outlet></router-outlet>
  </main>
  <footer>
    <app-footer leftFooterText="&copy; CLEPA 2026"></app-footer>
  </footer>
  